"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CANCELED = exports.FAILED = exports.SUCCEEDED = exports.SUBMITTED = exports.PENDING = void 0;
var PENDING = 'PENDING';
exports.PENDING = PENDING;
var SUBMITTED = 'SUBMITTED';
exports.SUBMITTED = SUBMITTED;
var SUCCEEDED = 'SUCCEEDED';
exports.SUCCEEDED = SUCCEEDED;
var FAILED = 'FAILED';
exports.FAILED = FAILED;
var CANCELED = 'CANCELED';
exports.CANCELED = CANCELED;